'use client'

import { useEffect, useSyncExternalStore } from 'react'
import { usePathname } from 'next/navigation'
import { crumbLabelsVersion, documentTitleFor, subscribeCrumbLabels } from '@/lib/nav-paths'

/**
 * Keeps the browser tab title in step with the route and the breadcrumb, so
 * leaving the Workbench never leaves "Invoice INV-310001 | AI Workbench" behind.
 */
export function DocumentTitle({ fallback }: { fallback?: string }) {
  const pathname = usePathname()
  const version = useSyncExternalStore(subscribeCrumbLabels, crumbLabelsVersion, crumbLabelsVersion)
  useEffect(() => {
    document.title = fallback ?? documentTitleFor(pathname)
  }, [pathname, version, fallback])
  return null
}
